import * as Sentry from '@sentry/react';

type Context = {
  tags?: Record<string, string>;
  extras?: Record<string, unknown>;
};

export function sentryLogger(err: unknown, ctx?: Context) {
  Sentry.withScope((scope) => {
    if (ctx?.tags) scope.setTags(ctx.tags);
    if (ctx?.extras) scope.setExtras(ctx.extras);

    if (err instanceof Error) {
      Sentry.captureException(err);
    } else {
      Sentry.captureMessage(String(err), 'error');
    }
  });
}
